import { useEffect, useState } from "react";
import styled from "styled-components"


type PaginationItemProps = {
  page: number
  count: number
  rowsOfPage: number
  onChangePage: (page: number) => void
}


export default function PaginationItem(props: PaginationItemProps) {

  const [pageArray, setPageArray] = useState<number[]>([])

  const [nextPage, setNextPage] = useState(0);

  useEffect(() => {

    let totalPage = Math.floor(props.count / props.rowsOfPage)
    if(props.count % props.rowsOfPage !== 0) totalPage += 1
    let array = [...Array(totalPage)].map((v, i) => i + 1)

    if(array.length === 0) array.push(1)

    setPageArray(array)
  }, [props])

  // useEffect(() => {
  //   if(curPage === undefined) return

  //   props.onChangePage(curPage)
  // }, [curPage])
  
  return (
    <PaginationItemDiv className="pagination">
      <button type="button"
        className="prev"
        onClick={e => {
          if(nextPage >= 1) {
            setNextPage(nextPage - 1)
            props.onChangePage((nextPage - 1) * 5 + 5)
          }
        }}
      />

      {pageArray.slice(nextPage * 5, (nextPage + 1) * 5).map((page, index) => (
        <button type="button" 
          className={`${page === props.page && 'active'}`}
          key={`page${index}`}
          onClick={e => {
            props.onChangePage(page)
          }}
        >{page}</button>
      ))}

      <button type="button"
        className="next"
        onClick={e => {
          if(props.count / props.rowsOfPage > ((nextPage + 1) * 5)) {
            setNextPage(nextPage + 1)
            props.onChangePage((nextPage + 1) * 5 + 1)
          }
        }}
      />
    </PaginationItemDiv>
  )
}

const PaginationItemDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  button{
    width: 36px;
    height: 36px;
    border: none;

    &:not(.prev), &:not(.next){
      font-size: 18px;
      color: var(--gray_9a);
      background-color: transparent;

      + &:not(.prev), &:not(.next){
        margin: 0 0 0 4px;
      }

      &.active{
        color: var(--main);
      }
    }

    &.prev, &.next{
      padding: 6px;
    }

    &.prev{
      margin: 0 8px 0 0;
      background: url(/images/ic_prev.svg) no-repeat center center;
    }

    &.next{
      margin: 0 0 0 8px;
      background: url(/images/ic_next.svg) no-repeat center center;
    }
  }
`